import gsap from 'gsap';

import { useGSAP } from '@gsap/react';
import * as React from 'react';

export type Props = {};

const SIZE = 50;

gsap.registerPlugin(useGSAP);

function TransformOrigin(props: Props) {
  const {} = props;

  const ref = React.useRef<HTMLDivElement>(null);
  useGSAP(
    () => {
      gsap
        .timeline({
          repeat: -1,
        })
        .add('percent')
        .to('#rect-red', { duration: 1, rotate: 360, transformOrigin: '100% 100%' }, 'percent')
        .to('#div-red', { duration: 1, rotate: 360, transformOrigin: '100% 100%' }, 'percent')
        .add('keywords')
        .to('#rect-green', { duration: 1, rotate: 360, transformOrigin: 'center center' }, 'keywords')
        .to('#div-green', { duration: 1, rotate: 360, transformOrigin: 'center center' }, 'keywords')
        .add('value')
        .to('#rect-blue', { duration: 1, rotate: 360, transformOrigin: '0px 0px' }, 'value')
        .to('#div-blue', { duration: 1, rotate: 360, transformOrigin: '0px 0px' }, 'value');
    },
    {
      scope: ref,
    }
  );

  return (
    <div ref={ref} className="grid grid-cols-2 gap-1">
      <div className="border-gray-600 border">
        <svg>
          <g id="rect-red" transform="translate(10, 10)">
            <rect className="fill-red-400" width={SIZE} height={SIZE}></rect>
            <text alignmentBaseline="hanging">rect percent</text>
          </g>
          <g id="rect-green" transform="translate(100, 10)">
            <rect className="fill-green-400" width={SIZE} height={SIZE}></rect>
            <text alignmentBaseline="hanging">rect keyword</text>
          </g>
          <g id="rect-blue" transform="translate(200, 10)">
            <rect className="fill-blue-400" width={SIZE} height={SIZE}></rect>
            <text alignmentBaseline="hanging">rect value</text>
          </g>
        </svg>
      </div>
      <div className="border-gray-600 border relative">
        <div
          id="div-red"
          className="absolute bg-red-400"
          style={{
            width: SIZE,
            height: SIZE,
            top: 10,
            left: 10,
          }}
        >
          div percent
        </div>
        <div
          id="div-green"
          className="absolute bg-green-400"
          style={{
            width: SIZE,
            height: SIZE,
            top: 10,
            left: 100,
          }}
        >
          div keyword
        </div>
        <div
          id="div-blue"
          className="absolute bg-blue-400"
          style={{
            width: SIZE,
            height: SIZE,
            top: 10,
            left: 200,
          }}
        >
          div value
        </div>
      </div>
    </div>
  );
}

export default React.memo(TransformOrigin);
